export default __webpack_public_path__ + "static/media/close-button.437830ca.svg";